const HeaderActionType = {
    "MINIMIZE": "MINIMIZE",
    "MAXIMIZE": "MAXIMIZE",
    "CLOSE": "CLOSE"
}

export default HeaderActionType;



// WEBPACK FOOTER //
// ./src/enums/action-types/HeaderActionType.js